import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import App from './App';
import { AuthProvider } from "react-oidc-context";
import * as serviceWorker from './serviceWorker';
import { WebStorageStateStore } from 'oidc-client-ts';

const oidcConfig = {
    authority: process.env.REACT_APP_KEYCLOAK_URL,
    client_id: process.env.REACT_APP_KEYCLOAK_CLIENT,
    redirect_uri: `${window.location.origin}/callback`,
    post_logout_redirect_uri: window.location.origin,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    onSigninCallback: (user) => {
        // console.log(user)
        window.location.replace('/')
        // window.history.replaceState(
        //     {},
        //     '',
        //     window.location.pathname
        // )
    }
    // ...
};

ReactDOM.render(
    <AuthProvider {...oidcConfig}>
        <App />
    </AuthProvider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
